class Statblock {
  constructor(strength, agility, toughness) {
    this.strength = strength;
    this.agility = agility;
    this.toughness = toughness;
  }

  get strengthModifier() {
    return Math.floor((this.strength - 10) / 2);
  }

  get agilityModifier() {
    return Math.floor((this.agility - 10) / 2);
  }

  get toughnessModifier() {
    return Math.floor((this.toughness - 10) / 2);
  }
}

export default Statblock;
